/**
 * Cart upload thumbnails → full-image lightbox (instead of new tab).
 * Closing the lightbox must NOT close the cart drawer.
 * Open/close use CSS transitions (is-open).
 */
(function () {
  if (window.__wod3dCartUploadLightbox) return;
  window.__wod3dCartUploadLightbox = true;

  const CLOSE_MS = 320;

  function modalEl() {
    return document.getElementById('WodCartUploadLightbox');
  }

  function isOpen() {
    const modal = modalEl();
    return Boolean(modal?.classList.contains('is-open'));
  }

  function ensureModal() {
    let modal = modalEl();
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'WodCartUploadLightbox';
    modal.className = 'wod-cart-upload-lightbox';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<button type="button" class="wod-cart-upload-lightbox__backdrop" data-wod-lightbox-close aria-label="Cerrar"></button>' +
      '<div class="wod-cart-upload-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Vista de imagen">' +
      '<button type="button" class="wod-cart-upload-lightbox__close" data-wod-lightbox-close aria-label="Cerrar">&times;</button>' +
      '<img class="wod-cart-upload-lightbox__img" alt="">' +
      '</div>';
    document.body.appendChild(modal);

    // Capture early so cart "click outside" / Escape handlers never see these events.
    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((type) => {
      modal.addEventListener(
        type,
        (event) => {
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          if (event.target.closest?.('[data-wod-lightbox-close]')) {
            event.preventDefault();
            close();
          }
        },
        true
      );
    });
    return modal;
  }

  function syncLock() {
    window.WodScrollLock?.sync?.();
  }

  function open(src, alt) {
    if (!src) return;
    const modal = ensureModal();
    if (modal._wodCloseTimer) {
      window.clearTimeout(modal._wodCloseTimer);
      modal._wodCloseTimer = 0;
    }
    const img = modal.querySelector('.wod-cart-upload-lightbox__img');
    if (img) {
      img.src = src;
      img.alt = alt || '';
    }
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('wod-cart-lightbox-open');
    // Force reflow so the open transition always runs
    void modal.offsetWidth;
    modal.classList.add('is-open');
    syncLock();
    modal.querySelector('.wod-cart-upload-lightbox__close')?.focus?.();
  }

  function close() {
    const modal = modalEl();
    if (!modal || (!modal.classList.contains('is-open') && !modal._wodClosing)) return;
    if (modal._wodClosing) return;
    modal._wodClosing = true;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    modal._wodCloseTimer = window.setTimeout(() => {
      modal._wodClosing = false;
      modal._wodCloseTimer = 0;
      const img = modal.querySelector('.wod-cart-upload-lightbox__img');
      if (img) {
        img.removeAttribute('src');
        img.alt = '';
      }
      document.documentElement.classList.remove('wod-cart-lightbox-open');
      const cartOpen = Boolean(
        document.querySelector('wod-sidebar-drawer.is-open, .wod-sidebar.is-open, cart-drawer.active') ||
          document.documentElement.classList.contains('wod-sidebar-lock')
      );
      if (!cartOpen) document.body.classList.remove('overflow-hidden');
      syncLock();
    }, CLOSE_MS);
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest?.('a.cart-upload-thumb-link');
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      const thumb = link.querySelector('img.cart-upload-thumb');
      open(link.getAttribute('href') || thumb?.currentSrc || thumb?.src, thumb?.alt || '');
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Escape' && event.code !== 'Escape') return;
      if (!isOpen()) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      close();
    },
    true
  );

  window.WodCartUploadLightbox = { isOpen, close };
})();
